import axios from "../../axios";

const getServiceCategories = async (st) => {
  st = st ? `service_type[$eq]=${st}` : "service_type[$eq]=service";
  try {
    const { data } = await axios.get(`/services/service_categories?${st}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getStations = async () => {
  try {
    const { data } = await axios.get(`/services/stations`);
    return data;
  } catch (e) {
    return null;
  }
};

const getStylists = async (service_id) => {
  try {
    const { data } = await axios.get(`/services/stylists/${service_id}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

export { getServiceCategories, getStations, getStylists };